export const generateColorValues = () => {
    const green = Math.floor(Math.random() * 101);
    const orange = Math.floor(Math.random() * (101 - green)); 
    const red = Math.floor(Math.random() * (101 - green - orange)); 
    const grey = 100 - (red + orange + green); 
  
    return { red, orange, green, grey };
  }
  